import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import { deleteStationsPriceReportSettings } from '../operations/deleteStationsPriceReportSettings';

import { STATUS_LOADING } from 'common/constants';

export const setStationsPriceReportSettingsDeletingStatus = (
  builder: ActionReducerMapBuilder<StationsState>
) => builder
  .addCase(deleteStationsPriceReportSettings.pending, (state) => {
    state.stationsPriceReportSettings.deletingStatus = STATUS_LOADING.load;
  })
  .addCase(deleteStationsPriceReportSettings.fulfilled, (state) => {
    state.stationsPriceReportSettings.deletingStatus = STATUS_LOADING.done;
  })
  .addCase(deleteStationsPriceReportSettings.rejected, (state) => {
    state.stationsPriceReportSettings.deletingStatus = STATUS_LOADING.error;
  });
